export default __webpack_public_path__ + "static/media/icon_target_date-within_7_days.522c5919.svg";